module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-form', {
    attrs: {
      "validate": _vm.validate,
      "value": _vm.value
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("邮箱")])]), _c('vbl-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('vbl-form-item', {
    attrs: {
      "name": "email"
    }
  }, [_c('vbl-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.value.email),
      callback: function($$v) {
        _vm.$set(_vm.value, "email", $$v)
      },
      expression: "value.email"
    }
  })], 1)], 1)], 1), _c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("联系地址")])]), _c('vbl-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('vbl-form-item', {
    attrs: {
      "name": "address"
    }
  }, [_c('vbl-select', {
    model: {
      value: (_vm.value.address),
      callback: function($$v) {
        _vm.$set(_vm.value, "address", $$v)
      },
      expression: "value.address"
    }
  }, [_c('vbl-option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("北京")]), _c('vbl-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("上海")]), _c('vbl-option', {
    attrs: {
      "value": "2",
      "disabled": ""
    }
  }, [_vm._v("广州")])], 1)], 1)], 1)], 1), _c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("描述")])]), _c('vbl-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('vbl-form-item', {
    attrs: {
      "name": "info"
    }
  }, [_c('vbl-textarea', {
    attrs: {
      "placeholder": "介绍一下"
    },
    model: {
      value: (_vm.value.info),
      callback: function($$v) {
        _vm.$set(_vm.value, "info", $$v)
      },
      expression: "value.info"
    }
  })], 1)], 1)], 1), _c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("喜欢吃的水果")])]), _c('vbl-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('vbl-form-item', {
    attrs: {
      "name": "fruit"
    }
  }, [_c('vbl-checkbox', {
    attrs: {
      "native-value": 0
    },
    model: {
      value: (_vm.value.fruit),
      callback: function($$v) {
        _vm.$set(_vm.value, "fruit", $$v)
      },
      expression: "value.fruit"
    }
  }, [_vm._v("香蕉")]), _c('vbl-checkbox', {
    attrs: {
      "native-value": 1
    },
    model: {
      value: (_vm.value.fruit),
      callback: function($$v) {
        _vm.$set(_vm.value, "fruit", $$v)
      },
      expression: "value.fruit"
    }
  }, [_vm._v("苹果")]), _c('vbl-checkbox', {
    attrs: {
      "native-value": 2,
      "disabled": ""
    }
  }, [_vm._v("梨")])], 1)], 1)], 1), _c('vbl-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('vbl-col', [_c('div', {
    staticClass: "form-btns"
  }, [_c('vbl-button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("提交")]), _c('vbl-button', {
    attrs: {
      "theme": "secondary"
    }
  }, [_vm._v("重置")])], 1)])], 1)], 1), _c('br'), _c('br'), _c('vbl-form', {
    attrs: {
      "validate": _vm.validateS,
      "value": _vm.valueS
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("用户名")])]), _c('vbl-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('vbl-form-item', {
    attrs: {
      "name": "username"
    }
  }, [_c('vbl-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.valueS.username),
      callback: function($$v) {
        _vm.$set(_vm.valueS, "username", $$v)
      },
      expression: "valueS.username"
    }
  })], 1)], 1)], 1), _c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("密码")])]), _c('vbl-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('vbl-form-item', {
    attrs: {
      "name": "password"
    }
  }, [_c('vbl-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.valueS.password),
      callback: function($$v) {
        _vm.$set(_vm.valueS, "password", $$v)
      },
      expression: "valueS.password"
    }
  })], 1)], 1)], 1), _c('vbl-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('vbl-col', [_c('div', {
    staticClass: "form-btns"
  }, [_c('vbl-button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("提交")]), _c('vbl-button', {
    attrs: {
      "theme": "secondary"
    }
  }, [_vm._v("重置")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-045700b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblForm/example/vblFormExample.vue
// module id = 241
// module chunks = 0